import { render } from "./NewsDetail.vue?vue&type=template&id=b89f19ac&scoped=true&ts=true"
import script from "./NewsDetail.vue?vue&type=script&setup=true&lang=ts"
export * from "./NewsDetail.vue?vue&type=script&setup=true&lang=ts"

import "./NewsDetail.vue?vue&type=style&index=0&id=b89f19ac&lang=scss&scoped=true"

import exportComponent from "/Users/luoke/Desktop/新开发代码_git/h5-jalalive/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b89f19ac"],['__file',"src/views/home/NewsDetail.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "b89f19ac"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('b89f19ac', __exports__)) {
    console.log('reload')
    api.reload('b89f19ac', __exports__)
  }
  
  module.hot.accept("./NewsDetail.vue?vue&type=template&id=b89f19ac&scoped=true&ts=true", () => {
    console.log('re-render')
    api.rerender('b89f19ac', render)
  })

}


export default __exports__